import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./HomePageStyles.css"; // Import the custom CSS file
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const API_URL = "https://sunrise-backend.sunrisemeditechsystems.com/api";

export default function Home() {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${API_URL}/products`);
      setProducts(res.data);
    } catch (error) {
      console.error("Failed to fetch products:", error);
      setProducts([]);
    }
  };

  // Helper to get N products for each section
  const getSectionProducts = (start, count) => {
    if (products.length === 0) return [];
    return products.slice(start, start + count);
  };

  // Helper for product click
  const handleProductClick = (id, name) => {
    console.log(`Redirecting to product details for product ID: ${id}`);
    if (name === "wishlist") {
      localStorage.setItem("wishlist_detail", name);
    }
    if (name === "cart") {
      localStorage.setItem("wishlist_detail", name);
    }
    navigate(`/product/${id}`);
  };

  // Helper for rendering a product card with the new attractive design
  const renderProductCard = (product) => (
    <div key={product.id} className="ltn__product-item">
      <div
        className="product-img"
        style={{ cursor: "pointer" }}
        onClick={() => handleProductClick(product.id)}
      >
        <img
          src={`https://sunrise-backend.sunrisemeditechsystems.com/${product.image}`}
          alt={product.name}
        />
        <div className="product-badge">
          <ul>
            {product.salePrice < product.rentalPrice && (
              <li className="sale-badge">Best for Sale</li>
            )}
            {product.rentalPrice < product.salePrice && (
              <li className="rental-badge">Best for Rent</li>
            )}
            {product.saleStock <= 0 && (
              <li className="sale-badge bg-danger">Out of Stock</li>
            )}
          </ul>
        </div>
        <div className="product-hover-action">
          <ul>
            <li>
              <Link
                to="#"
                title="Quick View"
                onClick={(e) => {
                  e.preventDefault();
                  handleProductClick(product.id, "cart");
                }}
              >
                <i className="far fa-eye" />
              </Link>
            </li>
            <li>
              <Link
                to="#"
                title="Add to Cart"
                onClick={(e) => {
                  e.preventDefault();
                  handleProductClick(product.id, "cart");
                }}
              >
                <i className="fas fa-shopping-cart" />
              </Link>
            </li>
            <li>
              <Link
                to="#"
                title="Add to Wishlist"
                onClick={(e) => {
                  e.preventDefault();
                  handleProductClick(product.id, "wishlist");
                }}
              >
                <i className="far fa-heart" />
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="product-info">
        <h2 className="product-title">
          <Link
            to="#"
            onClick={(e) => {
              e.preventDefault();
              handleProductClick(product.id);
            }}
          >
            {product.name}
          </Link>
        </h2>
        <div className="product-price">
          <span>₹{product.salePrice}</span>
          <del>₹{product.rentalPrice}/day</del>
        </div>
      </div>
    </div>
  );

  // Helper for rendering a section with a title and products
  const renderProductSection = (title, start, count, sectionClass = "") => (
    <div className={`ltn__product-area pt-65 pb-70 ${sectionClass}`}>
      <div className="container-fluid" style={{ width: "92%" }}>
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title-area ltn__section-title-2 text-center">
              <h1 className="section-title">{title}</h1>
            </div>
          </div>
        </div>
        <div className="row ltn__tab-product-slider-one-active--- slick-arrow-1">
          {getSectionProducts(start, count).map((product) => (
            <div key={product.id} className="col-lg-3 col-md-4 col-sm-6 col-6">
              {renderProductCard(product)}
            </div>
          ))}
          {products.length === 0 && (
            <div className="col-12 text-center">
              <p>No products found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="ltn__utilize-overlay" />
      {/* SLIDER AREA START (slider-3) */}
      <div className="ltn__slider-area ltn__slider-3--- section-bg-1--- mt-30">
        <div className="container-fluid" style={{ padding: "0 5%" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__slide-active-2 slick-slide-arrow-1 slick-slide-dots-1 mb-30">
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  navigation
                  pagination={{ clickable: true }}
                  autoplay={{ delay: 3000 }}
                  loop={true}
                  className="mySwiper"
                  style={{ height: "60vh", width: "1250px" }}
                >
                  {/* Slide 1 */}
                  <SwiperSlide>
                    <div
                      className="ltn__slide-item ltn__slide-item-10 section-bg-1 bg-image"
                      style={{
                        backgroundImage: `url('img/medical_health.jpg')`,
                      }}
                    >
                      <div className="ltn__slide-item-inner">
                        <div
                          className="container-fluid"
                          style={{ padding: "0 5%" }}
                        >
                          <div className="row">
                            <div className="col-lg-6 col-md-12 col-sm-12 align-self-center">
                              <div className="slide-item-info">
                                <div className="slide-item-info-inner ltn__slide-animation">
                                  <h6 className="slide-sub-title ltn__secondary-color animated text-uppercase">
                                    Up To 50% Off Today Only!
                                  </h6>
                                  <h1 className="slide-title animated">
                                    Gold Standard <br /> Pre-Workout
                                  </h1>
                                  <h5 className="color-orange animated">
                                    Starting at &amp;16.99
                                  </h5>
                                  <div className="btn-wrapper animated">
                                    <Link
                                      to="/shop"
                                      className="theme-btn-1 btn btn-effect-1"
                                    >
                                      Shop now
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                              <div className="ltn__banner-item">
                                <div className="ltn__banner-img" style={{marginTop:"-86px"}}>
                                  <Link to="/shop">
                                    <img
                                      src="img/image1.jpg"
                                      alt="Banner Image1"
                                      width={2000}
                                      height={450}
                                    />
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div
                      className="ltn__slide-item ltn__slide-item-10 section-bg-1 bg-image"
                      style={{
                        backgroundImage: `url('img/bg/healthcare.jpg')`,
                      }}
                    >
                      <div className="ltn__slide-item-inner">
                        <div
                          className="container-fluid"
                          style={{ padding: "0 5%" }}
                        >
                          <div className="row">
                            <div className="col-lg-6 col-md-12 col-sm-12 align-self-center">
                              <div className="slide-item-info">
                                <div className="slide-item-info-inner ltn__slide-animation">
                                  <h4 className="slide-sub-title ltn__secondary-color animated text-uppercase">
                                    Welcome to our shop
                                  </h4>
                                  <h1 className="slide-title animated">
                                    TGold Standard <br /> Pre-Workout
                                  </h1>
                                  <div className="slide-brief animated d-none">
                                    <p>
                                      Predictive analytics is drastically
                                      changing the real estate industry. In the
                                      past, providing data for quick
                                    </p>
                                  </div>
                                  <div className="btn-wrapper animated">
                                    <Link
                                      to="/shop"
                                      className="theme-btn-1 btn btn-effect-1 text-uppercase"
                                    >
                                      Shop now
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12">
                              <div className="ltn__banner-item">
                                <div className="ltn__banner-img" style={{marginTop:"-86px"}}>
                                  <Link to="/shop">
                                    <img
                                      src="img/image2.jpg"                                     
                                      alt="Banner Image2"
                                       width="100%"
                                      height={450}
                                    />
                                  </Link>
                                </div>
                              </div>
                            </div>
                            {/* <div className="col-lg-5 col-md-5 col-sm-5 align-self-center">
                              <div className="slide-item-img">
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
            {/* <div className="col-lg-5">
              <div className="ltn__banner-item">
                <div className="ltn__banner-img">
                  <Link to="/shop">
                    <img
                      src="img/banner/banner-9.jpeg"
                      alt="Banner Image1"
                      width={697}
                      height={372}
                    />
                  </Link>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* SLIDER AREA END */}
      {/* CATEGORY AREA START */}
      <div className="ltn__category-area section-bg-1-- pt-30 pb-50">
        <div className="container-fluid" style={{ padding: "0 90px 0 90px" }}>
          <div className="row ltn__category-slider-active-six slick-arrow-1 border-bottom">
            <div className="col-12">
              <div className="ltn__category-item ltn__category-item-6 text-center">
                <div className="ltn__category-item-img">
                  <Link to="/shop">
                    <i className="fas fa-notes-medical" />
                  </Link>
                </div>
                <div className="ltn__category-item-name">
                  <h6>
                    <Link to="/shop">Best Deals</Link>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="ltn__category-item ltn__category-item-6 text-center">
                <div className="ltn__category-item-img">
                  <Link to="/shop">
                    <i className="fas fa-box-tissue" />
                  </Link>
                </div>
                <div className="ltn__category-item-name">
                  <h6>
                    <Link to="/shop">Germs Pads</Link>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="ltn__category-item ltn__category-item-6 text-center">
                <div className="ltn__category-item-img">
                  <Link to="/shop">
                    <i className="fas fa-pump-medical" />
                  </Link>
                </div>
                <div className="ltn__category-item-name">
                  <h6>
                    <Link to="/shop">Accessories</Link>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="ltn__category-item ltn__category-item-6 text-center">
                <div className="ltn__category-item-img">
                  <Link to="/shop">
                    <i className="fas fa-bong" />
                  </Link>
                </div>
                <div className="ltn__category-item-name">
                  <h6>
                    <Link to="/shop">Medicine Cap</Link>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="ltn__category-item ltn__category-item-6 text-center">
                <div className="ltn__category-item-img">
                  <Link to="/shop">
                    <i className="fas fa-tooth" />
                  </Link>
                </div>
                <div className="ltn__category-item-name">
                  <h6>
                    <Link to="/shop">Dental Item</Link>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="ltn__category-item ltn__category-item-6 text-center">
                <div className="ltn__category-item-img">
                  <Link to="/shop">
                    <i className="fas fa-microscope" />
                  </Link>
                </div>
                <div className="ltn__category-item-name">
                  <h6>
                    <Link to="/shop">Best Deals</Link>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="ltn__category-item ltn__category-item-6 text-center">
                <div className="ltn__category-item-img">
                  <Link to="/shop">
                    <i className="fas fa-syringe" />
                  </Link>
                </div>
                <div className="ltn__category-item-name">
                  <h6>
                    <Link to="/shop">All Products</Link>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="ltn__category-item ltn__category-item-6 text-center">
                <div className="ltn__category-item-img">
                  <Link to="/shop">
                    <i className="fas fa-stethoscope" />
                  </Link>
                </div>
                <div className="ltn__category-item-name">
                  <h6>
                    <Link to="/shop">Germs Pads</Link>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="ltn__category-item ltn__category-item-6 text-center">
                <div className="ltn__category-item-img">
                  <Link to="/shop">
                    <i className="fas fa-hand-holding-medical" />
                  </Link>
                </div>
                <div className="ltn__category-item-name">
                  <h6>
                    <Link to="/shop">Accessories</Link>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="ltn__category-item ltn__category-item-6 text-center">
                <div className="ltn__category-item-img">
                  <Link to="/shop">
                    <i className="fas fa-procedures" />
                  </Link>
                </div>
                <div className="ltn__category-item-name">
                  <h6>
                    <Link to="/shop">Medicine Cap</Link>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* CATEGORY AREA END */}
      {/* DYNAMIC PRODUCT SECTIONS */}
      {renderProductSection(
        "Featured Products",
        0,
        4,
        "ltn__featured-products"
      )}
      {renderProductSection(
        "Trending Products",
        4,
        4,
        "ltn__trending-products"
      )}
      {renderProductSection("Best Selling Item", 8, 4, "ltn__best-selling")}

      {/* You can add more sections as needed, just change the title and the start/count if you want different products */}

      {/* ABOUT US AREA START */}
      <div
        className="ltn__about-us-area bg-image pt-115 pb-110"
        style={{ backgroundImage: `url('img/bg/26.jpg')` }}
      >
        <div className="container-fluid" style={{ padding: "0 6%" }}>
          <div className="row">
            <div className="col-lg-12 align-self-center">
              <div className="about-us-img-wrap about-img-left">
                {/* <img src="img/others/7.png" alt="About Us Image"> */}
              </div>
            </div>
            <div className="col-lg-8 align-self-center">
              <div className="about-us-info-wrap">
                <div className="section-title-area ltn__section-title-2--- mb-20">
                  <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
                    N95 Facial Covering Mask
                  </h6>
                  <h1 className="section-title">
                    Grade A Safety Masks For Sale. Hurry Up!
                  </h1>
                  <p>
                    Over 39,000 people work for us in more than 70 countries all
                    over the This breadth of global coverage, combined with
                    specialist services
                  </p>
                </div>
                <ul className="ltn__list-item-half clearfix">
                  <li>
                    <i className="flaticon-home-2" />
                    Activated Carbon
                  </li>
                  <li>
                    <i className="flaticon-mountain" />
                    Breathing Valve
                  </li>
                  <li>
                    <i className="flaticon-heart" />6 Layer Filteration
                  </li>
                  <li>
                    <i className="flaticon-secure" />
                    Rewashes &amp; Reusable
                  </li>
                </ul>
                <div className="btn-wrapper animated">
                  <Link
                    to="/shop"
                    className="ltn__secondary-color text-uppercase text-decoration-underline"
                  >
                    View Products
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ABOUT US AREA END */}
      {/* BLOG AREA START (blog-3) */}
      {/* <div className="container-fluid" style={{width:"80%"}}>
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color d-none">
                  News &amp; Blogs
                </h6>
                <h1 className="section-title">Leatest Blogs</h1>
              </div>
            </div>
          </div>
          <div className="row ltn__blog-slider-one-active slick-arrow-1 ltn__blog-item-3-normal">
            <div className="col-lg-12">
              <div className="ltn__blog-item ltn__blog-item-3">
                <div className="ltn__blog-img">
                  <Link to="blog-details.html">
                    <img src="img/blog/blog1.jpeg" className="blog-logo" alt="#" />
                  </Link>
                </div>
                <div className="ltn__blog-brief">
                  <div className="ltn__blog-meta">
                    <ul>
                      <li className="ltn__blog-author">
                        <Link to="#">
                          <i className="far fa-user" />
                          by: Admin
                        </Link>
                      </li>
                      <li className="ltn__blog-tags">
                        <Link to="#">
                          <i className="fas fa-tags" />
                          Decorate
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <h3 className="ltn__blog-title">
                    <Link to="blog-details.html">
                      10 Brilliant Ways To Decorate Your Home
                    </Link>
                  </h3>
                  <div className="ltn__blog-meta-btn">
                    <div className="ltn__blog-meta">
                      <ul>
                        <li className="ltn__blog-date">
                          <i className="far fa-calendar-alt" />
                          June 24, 2021
                        </li>
                      </ul>
                    </div>
                    <div className="ltn__blog-btn">
                      <Link to="blog-details.html">Read more</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="ltn__blog-item ltn__blog-item-3">
                <div className="ltn__blog-img">
                  <Link to="blog-details.html">
                    <img src="img/blog/blog2.jpeg" className="blog-logo" alt="#" />
                  </Link>
                </div>
                <div className="ltn__blog-brief">
                  <div className="ltn__blog-meta">
                    <ul>
                      <li className="ltn__blog-author">
                        <Link to="#">
                          <i className="far fa-user" />
                          by: Admin
                        </Link>
                      </li>
                      <li className="ltn__blog-tags">
                        <Link to="#">
                          <i className="fas fa-tags" />
                          Interior
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <h3 className="ltn__blog-title">
                    <Link to="blog-details.html">
                      The Most Inspiring Interior Design Of 2021
                    </Link>
                  </h3>
                  <div className="ltn__blog-meta-btn">
                    <div className="ltn__blog-meta">
                      <ul>
                        <li className="ltn__blog-date">
                          <i className="far fa-calendar-alt" />
                          July 23, 2021
                        </li>
                      </ul>
                    </div>
                    <div className="ltn__blog-btn">
                      <Link to="blog-details.html">Read more</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="ltn__blog-item ltn__blog-item-3">
                <div className="ltn__blog-img">
                  <Link to="blog-details.html">
                    <img src="img/blog/blog3.jpeg" className="blog-logo" alt="#" />
                  </Link>
                </div>
                <div className="ltn__blog-brief">
                  <div className="ltn__blog-meta">
                    <ul>
                      <li className="ltn__blog-author">
                        <Link to="#">
                          <i className="far fa-user" />
                          by: Admin
                        </Link>
                      </li>
                      <li className="ltn__blog-tags">
                        <Link to="#">
                          <i className="fas fa-tags" />
                          Estate
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <h3 className="ltn__blog-title">
                    <Link to="blog-details.html">
                      Recent Commercial Real Estate Transactions
                    </Link>
                  </h3>
                  <div className="ltn__blog-meta-btn">
                    <div className="ltn__blog-meta">
                      <ul>
                        <li className="ltn__blog-date">
                          <i className="far fa-calendar-alt" />
                          May 22, 2025
                        </li>
                      </ul>
                    </div>
                    <div className="ltn__blog-btn">
                      <Link to="blog-details.html">Read more</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="ltn__blog-item ltn__blog-item-3">
                <div className="ltn__blog-img">
                  <Link to="blog-details.html">
                    <img src="img/blog/blog4.jpeg" className="blog-logo" alt="#" />
                  </Link>
                </div>
                <div className="ltn__blog-brief">
                  <div className="ltn__blog-meta">
                    <ul>
                      <li className="ltn__blog-author">
                        <Link to="#">
                          <i className="far fa-user" />
                          by: Admin
                        </Link>
                      </li>
                      <li className="ltn__blog-tags">
                        <Link to="#">
                          <i className="fas fa-tags" />
                          Room
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <h3 className="ltn__blog-title">
                    <Link to="blog-details.html">
                      Renovating a Living Room? Experts Share Their Secrets
                    </Link>
                  </h3>
                  <div className="ltn__blog-meta-btn">
                    <div className="ltn__blog-meta">
                      <ul>
                        <li className="ltn__blog-date">
                          <i className="far fa-calendar-alt" />
                          June 24, 2025
                        </li>
                      </ul>
                    </div>
                    <div className="ltn__blog-btn">
                      <Link to="blog-details.html">Read more</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="ltn__blog-item ltn__blog-item-3">
                <div className="ltn__blog-img">
                  <Link to="blog-details.html">
                    <img src="img/blog/blog5.jpeg" className="blog-logo" alt="#" />
                  </Link>
                </div>
                <div className="ltn__blog-brief">
                  <div className="ltn__blog-meta">
                    <ul>
                      <li className="ltn__blog-author">
                        <Link to="#">
                          <i className="far fa-user" />
                          by: Admin
                        </Link>
                      </li>
                      <li className="ltn__blog-tags">
                        <Link to="#">
                          <i className="fas fa-tags" />
                          Trends
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <h3 className="ltn__blog-title">
                    <Link to="blog-details.html">
                      7 home trends that will shape your house in 2025
                    </Link>
                  </h3>
                  <div className="ltn__blog-meta-btn">
                    <div className="ltn__blog-meta">
                      <ul>
                        <li className="ltn__blog-date">
                          <i className="far fa-calendar-alt" />
                          June 24, 2025
                        </li>
                      </ul>
                    </div>
                    <div className="ltn__blog-btn">
                      <Link to="blog-details.html">Read more</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>           
          </div>
        </div> */}
      {/* BLOG AREA END */}
      {/* FEATURE AREA START ( Feature - 3) */}
      <div className="ltn__feature-area section-bg-1 mt-90--- pt-30 pb-30 mt--65---">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__feature-item-box-wrap ltn__feature-item-box-wrap-2 ltn__border--- section-bg-1">
                <div className="ltn__feature-item ltn__feature-item-8">
                  <div className="ltn__feature-icon">
                    <img src="img/icons/svg/8-trolley.svg" alt="#" />
                  </div>
                  <div className="ltn__feature-info">
                    <h4>Free shipping</h4>
                    <p>On all orders over $49.00</p>
                  </div>
                </div>
                <div className="ltn__feature-item ltn__feature-item-8">
                  <div className="ltn__feature-icon">
                    <img src="img/icons/svg/9-money.svg" alt="#" />
                  </div>
                  <div className="ltn__feature-info">
                    <h4>15 days returns</h4>
                    <p>Moneyback guarantee</p>
                  </div>
                </div>
                <div className="ltn__feature-item ltn__feature-item-8">
                  <div className="ltn__feature-icon">
                    <img src="img/icons/svg/10-credit-card.svg" alt="#" />
                  </div>
                  <div className="ltn__feature-info">
                    <h4>Secure checkout</h4>
                    <p>Protected by Paypal</p>
                  </div>
                </div>
                <div className="ltn__feature-item ltn__feature-item-8">
                  <div className="ltn__feature-icon">
                    <img src="img/icons/svg/11-gift-card.svg" alt="#" />
                  </div>
                  <div className="ltn__feature-info">
                    <h4>Offer &amp; gift here</h4>
                    <p>On all orders over</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* FEATURE AREA END */}
    </>
  );
}
